define('validation--sort-to-groups',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var answers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];


        if (!Array.isArray(questions) || !Array.isArray(answers)) {
            return false;
        }

        return questions.length && answers.length && answers.length === questions.reduce(function (res, o) {
            return res + document.querySelectorAll("[id=\"" + o.id + "\"] .js-sort-answer").length;
        }, 0) ? true : false;
    };
});
